import { toFormData, toJSON } from '../../../../Utils';
import { requestMethods } from '../../../../Constants/requestMethods';
import { path } from '../../Paths';
import { requestFactory } from '../../RequestFactory';

export const getWorkoutUrlForRequest = (filter, offset_id) => {
    const url = path.create().createWorkoutUrlRequest(filter, offset_id);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const getById = workoutId => {
    const url = path.create().getCurrentWorkout(workoutId);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const getWorkoutStockImage = workoutType => {
    const url = path.create().getWorkoutStockImage(workoutType);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const uploadWorkoutImage = file => {
    const url = path.create().uploadWorkoutImage();

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toFormData(file),
    };

    return requestFactory.createRequest(requestConfig);
};

export const createWorkout = data => {
    const url = path.create().createWorkout();

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toJSON(data),
    };

    return requestFactory.createRequest(requestConfig);
};

export const getPlannedWorkouts = (userId, offsetId, offsetDate) => {
    const url = path.create().getPlannedWorkouts(userId, offsetId, offsetDate);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const getWorkoutOfTheDayByDateRange = (start, end) => {
    const url = path.create().getWorkoutOfTheDayByDateRange(start, end);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const addWorkoutOfTheDay = data => {
    const url = path.create().addWorkoutOfTheDay();

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toJSON(data),
    };

    return requestFactory.createRequest(requestConfig);
};

export const getWorkoutOfTheWeek = mondayDate => {
    const url = path.create().getWorkoutOfTheWeek(mondayDate);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const addWorkoutOfTheWeek = data => {
    const url = path.create().addWorkoutOfTheWeek();

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toJSON(data),
    };

    return requestFactory.createRequest(requestConfig);
};



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/WorkoutApi/requestConfigs.js